import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private hasNoReportedCosts = new BehaviorSubject<string[]>([]);
  hasNoReportedCosts$ = this.hasNoReportedCosts.asObservable();
  private projektpartEligableForDirektsignering = new BehaviorSubject<string>(
    undefined,
  );
  projektpartEligableForDirektsignering$ =
    this.projektpartEligableForDirektsignering.asObservable();

  private isMVPSubject = new BehaviorSubject<boolean>(false);
  isMVP = this.isMVPSubject.asObservable();

  private isEnPartsProjektSubject = new BehaviorSubject<boolean>(false);
  isEnPartsProjekt$ = this.isEnPartsProjektSubject.asObservable();

  public getHasNoReportedCosts(): string[] {
    return this.hasNoReportedCosts.value;
  }

  public setHasNoReportedCostsValue(value: string) {
    const noReportedCostslist = this.hasNoReportedCosts.value;
    noReportedCostslist.push(value);
    this.hasNoReportedCosts.next(noReportedCostslist);
  }

  public removeHasNoReportedCostsValue(value: string) {
    this.hasNoReportedCosts.next(
      this.hasNoReportedCosts.value.filter((e) => e !== value),
    );
  }

  public resetHasNoReportedCostsValue() {
    this.hasNoReportedCosts.next([]);
  }

  public setProjektpartEligableForDirektsignering(value: string) {
    this.projektpartEligableForDirektsignering.next(value);
  }
  public getProjektpartEligableForDirektsignering(): string {
    return this.projektpartEligableForDirektsignering.value;
  }

  public setIsMVP(value: boolean): void {
    this.isMVPSubject.next(value);
  }
  public setIsEnPartsProjekt(value: boolean): void {
    this.isEnPartsProjektSubject.next(value);
  }
}
